import { useServices } from 'containers/services';
import { useAppNotifications } from 'hooks';
import type { CreateManufacturerArg, CreateManufacturerResult } from 'lib/services';
import { useMutation, type UseMutationOptions, type UseMutationResult, useQueryClient } from 'react-query';
import { getErrorMessage } from 'utils/getErrorMessage';
import { MUTATION_KEYS, QUERY_KEYS } from 'utils/queryKeys';

export const useCreateManufacturer = (
  options: UseMutationOptions<CreateManufacturerResult, unknown, CreateManufacturerArg> = {},
): UseMutationResult<CreateManufacturerResult, unknown, CreateManufacturerArg> => {
  const queryClient = useQueryClient();
  const { manufacturersApiClient } = useServices();
  const notify = useAppNotifications();

  return useMutation({
    mutationFn: async (arg: CreateManufacturerArg) => await manufacturersApiClient.create(arg),
    mutationKey: MUTATION_KEYS.manufacturers.create(),
    onError: error => {
      notify.error({
        message: 'There was an error while creating manufacturer',
        description: getErrorMessage(error),
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries(QUERY_KEYS.manufacturers.all());
      notify.success({
        message: `Manufacturer created`,
      });
    },
    ...options,
  });
};
